import { FeatureSet } from './feature-set';
import { Product } from './types';
import { memberProducts } from './products/member';

class MemberFeatureSet extends FeatureSet {
  constructor(memberProducts: Product[]) {
    super(memberProducts);
  }
}

export const MemberFeatures = new MemberFeatureSet(memberProducts);
